// SiteMap.jsx
import React, { useRef } from "react";
import "./css/SiteMap.css";
import SEO from "../components/SEO";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import locations from "../data/trips"

export default function SiteMap() {


  return (
    <>
    <SEO
        title="Site Map - Joujo Safaris"
        url="www.joujosafaris.com/sitemap"
        />
        <Navbar />
            <div className="container sitemap">
                <div className="career-main-title">
                <h4 className="text-color">SITEMAP</h4>
                <h5>The Pages</h5>
            </div>
                <ul className="sitemap-grid">
                    <li><a href="/home">Home</a></li>
                    <li><a href="/about">About Us</a></li>               
                    <li><a href="/careers">Careers</a></li>
                    <li><a href="/complain">Complain</a></li>
                    <li><a href="./contact">Contact Us</a></li>
                    <li><a href="./Countries">Countries</a></li>
                    <li><a href="/gallery">Our Gallery</a></li>
                    <li><a href="./about#team">Our Team</a></li>
                    <li><a href="/privacy">Privacy Policy</a></li>
                    <li><a href="./sitemap">Site Map</a></li>
                    <li><a href="/terms">Terms of Service</a></li>
                    <li><a href="#">Work With Us</a></li>
                </ul>
                <div className="container sitemap">
                <div className="career-main-title">
                <h4 className="text-color">SITEMAP</h4>
                <h5>The Trips</h5>


                <ul className="simap">
                        {locations.map((loc, index) => (
                          <li key={index}><a href={`/explore/${loc.name}`}>{loc.name}</a></li>
                        ))}
                      </ul>
                </div>
            </div>
            </div>
        <Footer />

    </>
  );
}
// import React from "react";
// import trips from "../data/trips";

// export default function Sitemap() {
//   const BASE_URL = "https://joujosafaris.com";

//   // Static pages
//   const staticPages = [
//     { url: "/", changefreq: "daily", priority: 1.0 },
//     { url: "/about", changefreq: "monthly", priority: 0.8 },
//     { url: "/contact", changefreq: "monthly", priority: 0.8 },
//     { url: "/careers", changefreq: "monthly", priority: 0.6 },
//     { url: "/trips", changefreq: "weekly", priority: 0.9 },
//     { url: "/gallery", changefreq: "monthly", priority: 0.6 },
//   ];

//   // Build XML dynamically
//   const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
// <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
// ${staticPages
//   .map(
//     (page) => `
//   <url>
//     <loc>${BASE_URL}${page.url}</loc>
//     <changefreq>${page.changefreq}</changefreq>
//     <priority>${page.priority}</priority>
//     <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>
//   </url>
//   `
//   )
//   .join("")}

// ${trips
//   .map(
//     (trip) => `
//   <url>
//     <loc>${BASE_URL}/trips/${trip.name}</loc>
//     <changefreq>weekly</changefreq>
//     <priority>0.9</priority>
//     <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>
//   </url>
//   `
//   )
//   .join("")}
// </urlset>`;

//   // ✅ JSON-LD Structured Data for Trips
//   const structuredData = {
//     "@context": "https://schema.org",
//     "@type": "ItemList",
//     name: "Joujo Safaris Trips",
//     description:
//       "Explore unforgettable safaris, luxury getaways, and adventure trips across Africa with Joujo Safaris.",
//     itemListElement: trips.map((trip, index) => ({
//       "@type": "TouristTrip",
//       position: index + 1,
//       name: trip.name,
//       url: `${BASE_URL}/explore/${trip.name}`,
//       dateModified: new Date().toISOString().split("T")[0],
//       provider: {
//         "@type": "TravelAgency",
//         name: "Joujo Safaris",
//         url: BASE_URL,
//       },
//     })),
//   };

//   const blob = new Blob([sitemap], { type: "application/xml" });
//   const sitemapUrl = URL.createObjectURL(blob);

//   return (
//     <div style={{ padding: "40px", textAlign: "center" }}>
//       <h2>Sitemap + Structured Data</h2>
//       <p>
//         Your sitemap and structured data are auto-generated from trips.js and
//         static pages.
//       </p>

//       {/* Download link */}
//       <a
//         href={sitemapUrl}
//         download="sitemap.xml"
//         style={{
//           padding: "10px 20px",
//           background: "#0d3b2e",
//           color: "#fff",
//           borderRadius: "5px",
//           textDecoration: "none",
//         }}
//       >
//         Download sitemap.xml
//       </a>

//       {/* Preview Sitemap */}
//       <h3 style={{ marginTop: "30px" }}>Generated sitemap.xml</h3>
//       <pre
//         style={{
//           textAlign: "left",
//           background: "#f5f5f5",
//           padding: "20px",
//           marginTop: "10px",
//           borderRadius: "8px",
//           maxHeight: "300px",
//           overflow: "auto",
//         }}
//       >
//         {sitemap}
//       </pre>

//       {/* Preview JSON-LD */}
//       <h3 style={{ marginTop: "30px" }}>Generated JSON-LD Structured Data</h3>
//       <pre
//         style={{
//           textAlign: "left",
//           background: "#eef",
//           padding: "20px",
//           marginTop: "10px",
//           borderRadius: "8px",
//           maxHeight: "300px",
//           overflow: "auto",
//         }}
//       >
//         {JSON.stringify(structuredData, null, 2)}
//       </pre>

//       {/* Inject JSON-LD for SEO */}
//       <script type="application/ld+json">
//         {JSON.stringify(structuredData)}
//       </script>
//     </div>
//   );
// }
